import { Controller } from "@hotwired/stimulus";

// Copies the source field's value to the clipboard and briefly swaps the
// button label to a "copied" confirmation.
export default class extends Controller {
    static targets = ["source", "button"];
    static values = { copiedLabel: String };

    connect() {
        if (this.hasButtonTarget) this.originalLabel = this.buttonTarget.textContent;
    }

    select() {
        this.sourceTarget.select();
    }

    copy() {
        this.select();

        // navigator.clipboard only exists in a secure context (HTTPS or
        // localhost); over plain HTTP (e.g. a dev host on a LAN IP) it is
        // undefined, so fall back to the legacy execCommand path.
        if (navigator.clipboard) {
            navigator.clipboard.writeText(this.sourceTarget.value)
                .then(() => this.flashCopied(), () => this.fallbackCopy());
        } else {
            this.fallbackCopy();
        }
    }

    fallbackCopy() {
        this.select();
        try {
            if (document.execCommand("copy")) this.flashCopied();
        } catch {
            // Copy failed; leave the text selected so the user can copy manually.
        }
    }

    flashCopied() {
        if (!this.hasButtonTarget || !this.hasCopiedLabelValue) return;

        this.buttonTarget.textContent = this.copiedLabelValue;
        window.setTimeout(() => {
            this.buttonTarget.textContent = this.originalLabel;
        }, 2000);
    }
}
